module.exports = __webpack_public_path__ + "static/img/fish14.35fb769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish14.png
// module id = it0P
// module chunks = 0